export enum Country {
    KR = 'KR',
    JP = 'JP',
}

export interface UserInfo {
  id: number;
  uuid: string;
  phoneNumber?: string;
  birthdaymmdd?: string;
  age?: number;
  name?: string;
  gender?: 'female' | 'male';
  country: Country;
}

export interface StoreInfo {
  name: string;
}

export interface EditMyInfoProps {
  accessToken: string;
  userInfo: UserInfo;
  handleUserChanges?: (u: UserInfo) => void;
}

export interface Point {
  place: {
    id: string;
    name: string;
    payablePointPolicy: {
      minimumRequiredPoint: number | null;
    };
    rewards: {
      cost: number;
      name: string;
    }[];
  };
  point: {
    createdAt: string;
    lastVisitedAt: string;
    points: number;
    savedPoints: number;
  };
}

export interface ActivityData {
  createdAt: string;
  points: number;
  store: {
    id: string;
    name: string;
  };
  type: string;
}

export enum ButtonStatus {
    Normal,
    Active,
    Disabled,
}
